import { Component, OnChanges, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { RoleNamePipe } from '@sb-tools/typescript/pipes/role-name.pipe';
import { UserAvatarService } from './user-avatar.service';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { BaseUserDTO } from '@sb-tools/typescript/models/dto/base-user.dto';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgStyle } from '@angular/common';
import { AvatarModule } from 'ngx-avatars';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'sb-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [RoleNamePipe],
    imports: [TranslateModule, NgStyle, AvatarModule, RoleNamePipe, NgClass, TooltipModule],
})
export class UserAvatarComponent implements OnInit, OnChanges {
    @Input() isNeedTooltip?: boolean;
    @Input() size?: string;
    @Input() tooltipPlacement?: AvailableBSPositions;
    @Input() tooltipText?: string;
    @Input() user: CommunityUser | BaseUserWithRole | BaseUserDTO;
    @Input() withLabel?: boolean = false;
    @Input() withRoleTooltip?: boolean = false;

    avatarSize: number;
    isDarkMode: boolean;
    isTeamMember: boolean;
    tooltip: string;
    userAvatarSize: string;
    userLabel: string;
    userLabelLetter: string;
    userRoleEnum = UserRole;

    constructor(
        public userAvatarService: UserAvatarService,
        public roleNamePipe: RoleNamePipe,
    ) {
        this.isDarkMode = document.body.classList.contains('dark-theme');
    }

    ngOnInit() {
        this.initAvatarData();
    }

    ngOnChanges() {
        this.initAvatarData();
    }

    private initAvatarData() {
        if (!this.user) {
            this.user = new CommunityUser();
        }

        this.isTeamMember = this.user.role > 0;

        this.userLabel = this.user.name || this.user.email;
        this.userLabelLetter = this.userLabel ? this.userLabel.trim()[0] : '';

        if (this.isNeedTooltip) {
            this.tooltip = this.tooltipText || this.userLabel;
        } else if (this.withRoleTooltip && this.isTeamMember) {
            this.tooltip = this.roleNamePipe.transform(this.user.role);
        }

        if (!this.tooltipPlacement) {
            this.tooltipPlacement = 'top';
        }

        switch (this.size) {
            case 'xLarge':
                this.avatarSize = 120;
                this.userAvatarSize = 'user-avatar-xlg';
                break;
            case 'large':
                this.avatarSize = 80;
                this.userAvatarSize = 'user-avatar-lg';
                break;
            case 'small':
                this.avatarSize = 34;
                this.userAvatarSize = 'user-avatar-sm';
                break;
            case 'btn':
                this.avatarSize = 24;
                this.userAvatarSize = 'user-avatar-btn';
                break;
            case 'extra-small':
                this.avatarSize = 26;
                this.userAvatarSize = 'user-avatar-xs';
                break;
            case 'extra-extra-small':
                this.avatarSize = 20;
                this.userAvatarSize = 'user-avatar-xxs';
                break;
            default:
                this.avatarSize = 40;
                this.userAvatarSize = '';
        }
    }
}
